import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { changeCustomerBillToSelectorStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerBillToSelector";

import { css } from "styled-components";

changeCustomerBillToSelectorStyles.billToSelectorDynamicDropdown = mergeToNew(
    changeCustomerBillToSelectorStyles.billToSelectorDynamicDropdown,
    {
        cssOverrides: {
            list: css`
                max-height: 250px;
                border-left: none;
                border-right: none;
                overflow-y: auto;
            `,
        },
    },
);
